import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ecc03ece&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ecc03ece&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc03ece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecc03ece')) {
      api.createRecord('ecc03ece', component.options)
    } else {
      api.reload('ecc03ece', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ecc03ece&scoped=true", function () {
      api.rerender('ecc03ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/lottery-assistant/homeMenu/index.vue"
export default component.exports